import { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { CHAT_API_BASE_URL } from "../config";
import ChatServices from "../services/chat.services";
import { useMessageCount } from "../MessageContext";

var stompClient = null;
const useChatNotificationService = () => {
  const { incrementNewMessageCount, allChats, setAllChats } = useMessageCount();
  const [messageCount, setMessageCount] = useState(0);

  const token = localStorage.getItem("user");
  const decoded = token ? jwtDecode(token) : null;
  const UserId = decoded?.sub;
  const connect = () => {
    const Stomp = require("stompjs");
    var SockJS = require("sockjs-client");
    SockJS = new SockJS(CHAT_API_BASE_URL);
    stompClient = Stomp.over(SockJS);
    stompClient.connect({}, onConnected, onError);
  };

  const onError = (error) => {
    console.log("Error:", error);
  };

  const onConnected = () => {
    stompClient.subscribe(
      "/user/" + UserId + "/queue/messages",
      onMessageReceived
    );
  };

  const onMessageReceived = (msg) => {
    const message = JSON.parse(msg.body);

    // console.log('Received a new message:', msg);
    if (message.senderId != UserId) {
      // setMessageCount(messageCount + 1);
      getAllChatsRecentHandler()
    }
  };

  const getAllChatsRecentHandler = async () => {
    try {
      let res = await ChatServices.getAllChats();
      const chatData = res.data || [];
      setAllChats(chatData);
      let msgCount = chatData.map(item => item.messageCount) || [];
      const sumCount = msgCount?.reduce((accumulator, currentValue) => accumulator + (currentValue || 0), 0) || 0;
      incrementNewMessageCount(sumCount);
    } catch (error) {
      console.error("Failed to fetch recent chats for notification count", error);
    }
  };

  // useEffect(() => {
  //   connect();
  //   // getAllChatsRecentHandler()
  // }, []);

  return { allChats, messageCount, getAllChatsRecentHandler, setMessageCount, connect };
};

export default useChatNotificationService;
